import { render, staticRenderFns } from "./StockTransactionUpdate.vue?vue&type=template&id=5a847108&scoped=true"
import script from "./StockTransactionUpdate.vue?vue&type=script&lang=js"
export * from "./StockTransactionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a847108",
  null
  
)

export default component.exports